// Shared invoice status helpers — used by both InvoiceItem.js (detail page)
// and InvoiceTable.js (list "Estado" column) so the label/tone mapping stays
// consistent across the whole Invoice module.

// Maps the invoice's `status` field to a display label + pill tone.
// Falls back to inferring the state from other signals (reprove_reason,
// approved) when `status` isn't present on the payload.
export const STATUS_META = {
  created: { label: 'Criada', tone: 'pending' },
  waiting_approval: { label: 'Para Aprovação', tone: 'pending' },
  to_approve: { label: 'Para Aprovação', tone: 'pending' },
  approved: { label: 'Aprovada', tone: 'success' },
  completed: { label: 'Registada', tone: 'success' },
  registered: { label: 'Registada', tone: 'success' },
  refused: { label: 'Recusada', tone: 'danger' },
  rejected: { label: 'Recusada', tone: 'danger' },
  reproved: { label: 'Recusada', tone: 'danger' },
}

export function getStatusMeta(invoice) {
  // The outcome fields win over `status`: index_completed returns both accepted
  // and refused invoices, and on those `status` only says the invoice reached
  // the end of the flow ('completed'), not how it ended. DefaultTemplate reads
  // the same two fields for its "Aceite"/"Razão" columns.
  if (invoice.reprove_reason) return STATUS_META.refused
  //if (invoice.approved === 'approved') return STATUS_META.approved
  if (invoice.approved && STATUS_META[invoice.approved]) return STATUS_META[invoice.approved]
  return null
}
